/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FapResponseDto = {
    /**
     * Unique FAP identifier (UUID)
     */
    id: string;
    /**
     * Legal name of the FAP
     */
    legalName: string;
    /**
     * Trading name of the FAP
     */
    tradingName?: string | null;
    /**
     * FAP licence number
     */
    fapLicenceNumber: string;
    /**
     * FSPR (Financial Service Providers Register) number
     */
    fsprNumber: string;
    /**
     * GST number
     */
    gstNumber?: string | null;
    /**
     * Default authorised rep commission percentage
     */
    commissionPercentage?: number | null;
    /**
     * Default override percentage (fallback when adviser has no override set)
     */
    overridePercentage?: number | null;
    /**
     * Default override name (fallback when adviser has no override name set)
     */
    overrideName?: string | null;
    /**
     * Default broker fee percentage
     */
    brokerFeePercentage?: number | null;
    /**
     * Default quoting adviser new business commission percentage
     */
    qaCommissionPercentage?: number | null;
    /**
     * Default quoting adviser renewal commission percentage
     */
    qaRenewalCommissionPercentage?: number | null;
    /**
     * FAP status
     */
    status: FapResponseDto.status;
    /**
     * Primary contact person name
     */
    primaryContactName: string;
    /**
     * Primary contact email address
     */
    primaryContactEmail: string;
    /**
     * Primary contact phone number
     */
    primaryContactPhone: string;
    /**
     * Banking account name
     */
    bankingAccountName: string;
    /**
     * Banking account number
     */
    bankingAccountNumber: string;
    /**
     * Banking reference format
     */
    bankingReferenceFormat?: string | null;
    /**
     * Additional notes about the FAP
     */
    notes?: string | null;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
    /**
     * UUID of the user who created this FAP
     */
    createdBy?: string | null;
    /**
     * UUID of the user who last updated this FAP
     */
    updatedBy?: string | null;
};
export namespace FapResponseDto {
    /**
     * FAP status
     */
    export enum status {
        ACTIVE = 'active',
        INACTIVE = 'inactive',
    }
}

